var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fast-fade" } },
    [
      _vm.ready
        ? _c(
            "w-row",
            { attrs: { grow: "", shrink: "", "no-margin": "" } },
            [
              _vm.$wf.isMdUp
                ? _c(
                    "w-col",
                    {
                      staticClass: "calendar-list",
                      attrs: {
                        sm: "12",
                        md: "3",
                        grow: "",
                        shrink: "",
                        "no-margin": "",
                        "no-padding": "",
                      },
                    },
                    [_c("app-calendar-list", { attrs: { state: _vm.state } })],
                    1
                  )
                : _vm.selectCalendarOpen
                ? _c(
                    "app-base",
                    [
                      _c(
                        "app-toolbar",
                        { attrs: { "drawer-button-disabled": "" } },
                        [
                          _c(
                            "w-toolbar-text",
                            {
                              staticClass: "app-title",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("select-calendars-title")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "w-toolbar-item",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.selectCalendarOpen = false
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        { attrs: { grow: "", shrink: "", "no-margin": "" } },
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", grow: "", shrink: "" } },
                            [
                              _c("app-calendar-list", {
                                attrs: { state: _vm.state },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                {
                  attrs: {
                    sm: "12",
                    md: "9",
                    grow: "",
                    shrink: "",
                    "no-margin": "",
                    "no-padding": "",
                  },
                },
                [
                  _c("app-calendar", {
                    attrs: { state: _vm.state, event: _vm.toEditEvent },
                    on: {
                      success: function ($event) {
                        return _vm.$emit("success")
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }